import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import NavigationView from '../NavigationView';
import {
  EmployeesCreatePageView,
  EmployeesDetailPageView,
  EmployeesPageView,
  EmployeesUpdatePageView,
  ApplicantsPageView,
} from '../employees';
import { AuthCallbackView, LoginPageView, ProfilePageView } from '../user';
import { ClientsCreatePageView, ClientsDetailPageView, ClientsPageView } from '../clients';
import {
  CampaignCreatePageView,
  CampaignUpdatePageView,
  ThemePageView,
} from '../clients/campaigns';
import { SettingsPageView, SettingsDetailPageView, SettingsUpdatePageView } from '../settings';
import {
  LocationsPageView,
  LocationCreatePageView,
  LocationUpdatePageView,
} from '../locations';
import { NotificationsPageView } from '../notifications';
import {
  NotificationConfigPageView,
  NotificationConfigDetailPageView,
  NotificationConfigEditPageView,
} from '../notification-config';
import { IntegrationsPageView } from '../integrations';
import { UsersPageView, UserFormPageView } from '../users';

const isAuthenticated = connectedRouterRedirect({
  redirectPath: '/',
  authenticatedSelector: (state) => state.user && state.user.roles != null,
  wrapperDisplayName: 'isAuthenticated',
});

const locationHelper = locationHelperBuilder({});
const isNotAuthenticated = connectedRouterRedirect({
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/profile/',
  allowRedirectBack: false,
  authenticatedSelector: (state) => !state.user || state.user.roles == null,
  wrapperDisplayName: 'isNotAuthenticated',
});

export function PrivateRoutes() {
  return (
    <Fragment>
      <NavigationView />

      <Route exact path="/" component={isNotAuthenticated(LoginPageView)} />
      <Route exact path="/auth-callback" component={AuthCallbackView} />

      <Route exact path="/clients/" component={isAuthenticated(ClientsPageView)} />
      <Route
        exact
        path="/clients/:clientId([0-9]+)/campaigns/create/"
        component={isAuthenticated(CampaignCreatePageView)}
      />
      <Route
        exact
        path="/clients/:clientId([0-9]+)/campaigns/:campaignId([0-9]+)/update/"
        component={isAuthenticated(CampaignUpdatePageView)}
      />
      <Route
        exact
        path="/clients/:clientId([0-9]+)/campaigns/:campaignId([0-9]+)/theme/"
        component={isAuthenticated(ThemePageView)}
      />

      <Route
        exact
        path="/clients/:clientId([0-9]+)/"
        component={isAuthenticated(ClientsDetailPageView)}
      />
      <Route exact path="/clients/create/" component={isAuthenticated(ClientsCreatePageView)} />

      <Route exact path="/employees/" component={isAuthenticated(EmployeesPageView)} />
      <Route exact path="/employees/create/" component={isAuthenticated(EmployeesCreatePageView)} />
      <Route
        exact
        path="/:resourceName(employees|applicants)/:employeeId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/"
        component={isAuthenticated(EmployeesDetailPageView)}
      />
      <Route
        exact
        path="/:resourceName(employees|applicants)/:employeeId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/update/"
        component={isAuthenticated(EmployeesUpdatePageView)}
      />

      <Route exact path="/applicants/" component={isAuthenticated(ApplicantsPageView)} />

      <Route exact path="/profile/" component={isAuthenticated(ProfilePageView)} />

      <Route exact path="/locations/" component={isAuthenticated(LocationsPageView)} />
      <Route exact path="/locations/create/" component={isAuthenticated(LocationCreatePageView)} />
      <Route
        exact
        path="/locations/:locationId([0-9]+)/update/"
        component={isAuthenticated(LocationUpdatePageView)}
      />

      <Route exact path="/notifications/" component={isAuthenticated(NotificationsPageView)} />

      <Route
        exact
        path="/notification-config/"
        component={isAuthenticated(NotificationConfigPageView)}
      />
      <Route
        exact
        path="/notification-config/:slug([a-z0-9-]+)/"
        component={isAuthenticated(NotificationConfigDetailPageView)}
      />
      <Route
        exact
        path="/notification-config/:slug([a-z0-9-]+)/edit/"
        component={isAuthenticated(NotificationConfigEditPageView)}
      />
      <Route
        exact
        path="/notification-config/:slug([a-z0-9-]+)/edit/:location([^/]+)/"
        component={isAuthenticated(NotificationConfigEditPageView)}
      />

      <Route exact path="/settings/" component={isAuthenticated(SettingsPageView)} />
      <Route
        exact
        path="/settings/:type([a-zA-Z_. \-]+)/:key([a-zA-Z_. \-]+)/"
        component={isAuthenticated(SettingsDetailPageView)}
      />
      <Route
        exact
        path="/settings/:type([a-zA-Z_. \-]+)/:key([a-zA-Z_. \-]+)/update/"
        component={isAuthenticated(SettingsUpdatePageView)}
      />

      <Route exact path="/integrations/" component={isAuthenticated(IntegrationsPageView)} />
      <Route exact path="/users/" component={isAuthenticated(UsersPageView)} />
      <Route exact path="/users/create/" component={isAuthenticated(UserFormPageView)} />
      <Route exact path="/users/:userId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/" component={isAuthenticated(UserFormPageView)} />
    </Fragment>
  );
}
